import { Component, OnInit } from '@angular/core';
import { Pack, PlcCodes } from '@dch/products-business-logic';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import { UserAccessService } from '../user-access.service';
import { UserRight } from '../model/user-right.model';
import { GetProducts } from '../../../store/actions/products.actions';
import { Store } from '@ngrx/store';
import { ApplicationState, getUserProduct } from '../../../store/reducers';
import { combineLatest } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'mprd-user-access-management',
  templateUrl: './user-access-management.component.html',
})
export class UserAccessManagementComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  pending = true;
  users: UserRight[] = [];

  constructor(
    private userAccessService: UserAccessService,
    private store: Store<ApplicationState>,
  ) {
    super();
  }

  ngOnInit(): void {
    setTimeout(() => this.store.dispatch(new GetProducts()));
    this.addSubscription(
      combineLatest([
        this.store.select(getUserProduct),
        this.userAccessService.fetchUserRights(),
      ]).subscribe(([products, users]) => {
        const personalMsisdn = this.findPersonalMsisdn(
          products?.packs,
          products?.outOfPacks,
        );
        this.users = users.filter((user) => user.msisdn !== personalMsisdn);
        this.pending = false;
      }),
    );
  }

  private findPersonalMsisdn(
    packs: Pack[] | undefined = [],
    outOfPacks: Pack[] | undefined = [],
  ): string | undefined {
    for (const pack of [...packs, ...outOfPacks]) {
      for (const product of pack?.coreProducts ?? []) {
        if (
          product?.plc === PlcCodes.MV &&
          product.myMobile &&
          product.accessNumber
        ) {
          return product.accessNumber;
        }
      }
    }
    return undefined;
  }

  deactivateAllUsers(): void {
    for (const user of this.users) {
      user.hasRight = false;
    }
  }

  confirmChanges(): void {
    this.pending = true;
    this.addSubscription(
      this.userAccessService
        .updateUserRights(this.users)
        .pipe(finalize(() => (this.pending = false)))
        .subscribe(),
    );
  }
}
